module.exports = __webpack_public_path__ + "static/img/joud.849273c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing-page/joud.jpg
// module id = 431
// module chunks = 1